import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15 .545 12.68 6H11l2.552-6L15 .545ZM19.994 13.42c-.042-.971-.244-1.76-.616-2.41-.332-.579-.802-1.05-1.437-1.439-.579-.354-1.28-.546-2.025-.556l-.127-.002-.019-.342A.694.694 0 0 0 15.092 8H4.425c-.277 0-.48.272-.412.552l.88 3.682-.581 9.007c-.026.41.285.759.678.759H15.78c.39 0 .7-.344.678-.752l-.057-1.047.112-.152c.2-.256 1.658-1.761 1.923-2.07a6.645 6.645 0 0 0 1.559-4.559Zm-2.773 2.972a3.481 3.481 0 0 1-.985.767h-.001l-.337-5.922c0-.016.006-.027.012-.034l.002-.002a.053.053 0 0 1 .036-.015h.005c.431 0 .823.09 1.135.26.53.288 1.1.709 1.178 2.07.085 1.48-.703 2.504-1.045 2.876Z"
    }, null, -1)
  ]))]))
}
export default { render: render }